// components/SimilarProfiles/SimilarProfiles.jsx
import React, { forwardRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Publicationfromevents1 from "../../../assets/images/publicationfromevents1.svg";

import styles from "./Publications.module.css";

const Publications = forwardRef(({ profiles }, ref) => (
  <div className={styles.pubicationSlider}>
    <Swiper
      className={styles.similarSwiper}
      autoplay={{ delay: 5000 }}
      loop={true}
      ref={ref}
      observer={true}
      observeParents={true}
      modules={[Navigation, Autoplay]}
      spaceBetween={20}
      slidesPerView={3}
      onBeforeInit={(swiper) => {
        swiper.params.navigation.prevEl = ".similar-prev";
        swiper.params.navigation.nextEl = ".similar-next";
      }}
      breakpoints={{
        320: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 2 },
      }}
    >
      {profiles.map((profile, idx) => (
        <SwiperSlide key={idx}>
          <div className={styles.publicationsCard}>
            <div className={styles.left}>
              <img
                src={Publicationfromevents1}
                alt="Climate Innovation Conference 2023"
              />
            </div>
            <div className={styles.right}>
              <h4>Climate Innovation Conference 2023</h4>
              <p>
                Complete proceedings from the International climate innovation
                summit
              </p>
            </div>
            <div className={styles.actions}>
              <span className={styles.tag}>Proceedings</span>
              <span className={styles.pages}>89 papers</span>
              <button className={styles.viewBtn}>View Proceedings</button>
            </div>
          </div>
        </SwiperSlide>
      ))}
      {/* ✅ custom arrows */}
    </Swiper>
    <div className="similar-prev">&nbsp;</div>
    <div className="similar-next">&nbsp;</div>
  </div>
));
export default Publications;
